import apiClient from './apiClient';

export interface CompanyContact {
  id: number;
  company_id: number;
  first_name: string;
  last_name: string;
  email?: string | null;
  phone?: string | null;
  position?: string | null;
  is_active: boolean;
}

export interface Company {
  id: number;
  name: string;
  account_number?: string | null;
  pricing_tier: number;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zip_code?: string | null;
  phone?: string | null;
  is_active: boolean;
  contacts: CompanyContact[];
}

export interface CompanyListItem {
  id: number;
  name: string;
  account_number?: string | null;
  pricing_tier: number;
  city?: string | null;
  state?: string | null;
  phone?: string | null;
  is_active: boolean;
  contact_count: number;
}

const companiesApi = {
  list: (params?: string | { search?: string; limit?: number }) => {
    const p = typeof params === 'string' ? { search: params } : params;
    return apiClient.get<CompanyListItem[]>('/companies', { params: p }).then(r => r.data);
  },

  get: (id: number) =>
    apiClient.get<Company>(`/companies/${id}`).then(r => r.data),

  create: (data: Partial<Company>) =>
    apiClient.post<Company>('/companies', data).then(r => r.data),

  update: (id: number, data: Partial<Company>) =>
    apiClient.put<Company>(`/companies/${id}`, data).then(r => r.data),

  listContacts: (companyId: number) =>
    apiClient.get<CompanyContact[]>(`/companies/${companyId}/contacts`).then(r => r.data),

  createContact: (companyId: number, data: Partial<CompanyContact>) =>
    apiClient.post<CompanyContact>(`/companies/${companyId}/contacts`, data).then(r => r.data),

  updateContact: (companyId: number, contactId: number, data: Partial<CompanyContact>) =>
    apiClient.put<CompanyContact>(`/companies/${companyId}/contacts/${contactId}`, data).then(r => r.data),
};

export default companiesApi;
